import {adminApi} from 'sources/api';

/**
 * `AdminUserAuditTrailSource` exposes APIs that fetch the targetUser's most
 * recent audit trails from the backend
 */
export default {
  retrieve(userId) {
    return adminApi.getJson(`/user_audit_trails/most_recent/${userId}`);
  },
};
